/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of MDM deduplication operation
 * @export
 * @interface MdmDeduplicationResult
 */
export interface MdmDeduplicationResult {
    /**
     * Number of entities scanned for duplicates
     * @type {number}
     * @memberof MdmDeduplicationResult
     */
    entitiesScanned?: number;
    /**
     * Number of duplicate candidates found
     * @type {number}
     * @memberof MdmDeduplicationResult
     */
    candidatesFound?: number;
    /**
     * Number of candidates auto-merged (high confidence)
     * @type {number}
     * @memberof MdmDeduplicationResult
     */
    autoMerged?: number;
    /**
     * Number of candidates pending manual review
     * @type {number}
     * @memberof MdmDeduplicationResult
     */
    pendingReview?: number;
    /**
     * Number of golden records created
     * @type {number}
     * @memberof MdmDeduplicationResult
     */
    goldenRecordsCreated?: number;
    /**
     * Number of golden records updated
     * @type {number}
     * @memberof MdmDeduplicationResult
     */
    goldenRecordsUpdated?: number;
    /**
     * Number of comparisons performed
     * @type {number}
     * @memberof MdmDeduplicationResult
     */
    comparisonsPerformed?: number;
    /**
     * Start time
     * @type {Date}
     * @memberof MdmDeduplicationResult
     */
    startTime?: Date;
    /**
     * End time
     * @type {Date}
     * @memberof MdmDeduplicationResult
     */
    endTime?: Date;
    /**
     * Duration in milliseconds
     * @type {number}
     * @memberof MdmDeduplicationResult
     */
    durationMs?: number;
    /**
     * Whether deduplication was successful
     * @type {boolean}
     * @memberof MdmDeduplicationResult
     */
    success?: boolean;
    /**
     * Error message if failed
     * @type {string}
     * @memberof MdmDeduplicationResult
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the MdmDeduplicationResult interface.
 */
export function instanceOfMdmDeduplicationResult(value: object): value is MdmDeduplicationResult {
    return true;
}

export function MdmDeduplicationResultFromJSON(json: any): MdmDeduplicationResult {
    return MdmDeduplicationResultFromJSONTyped(json, false);
}

export function MdmDeduplicationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmDeduplicationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'entitiesScanned': json['entitiesScanned'] == null ? undefined : json['entitiesScanned'],
        'candidatesFound': json['candidatesFound'] == null ? undefined : json['candidatesFound'],
        'autoMerged': json['autoMerged'] == null ? undefined : json['autoMerged'],
        'pendingReview': json['pendingReview'] == null ? undefined : json['pendingReview'],
        'goldenRecordsCreated': json['goldenRecordsCreated'] == null ? undefined : json['goldenRecordsCreated'],
        'goldenRecordsUpdated': json['goldenRecordsUpdated'] == null ? undefined : json['goldenRecordsUpdated'],
        'comparisonsPerformed': json['comparisonsPerformed'] == null ? undefined : json['comparisonsPerformed'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
        'success': json['success'] == null ? undefined : json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function MdmDeduplicationResultToJSON(json: any): MdmDeduplicationResult {
    return MdmDeduplicationResultToJSONTyped(json, false);
}

export function MdmDeduplicationResultToJSONTyped(value?: MdmDeduplicationResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entitiesScanned': value['entitiesScanned'],
        'candidatesFound': value['candidatesFound'],
        'autoMerged': value['autoMerged'],
        'pendingReview': value['pendingReview'],
        'goldenRecordsCreated': value['goldenRecordsCreated'],
        'goldenRecordsUpdated': value['goldenRecordsUpdated'],
        'comparisonsPerformed': value['comparisonsPerformed'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'durationMs': value['durationMs'],
        'success': value['success'],
        'errorMessage': value['errorMessage'],
    };
}

